export default "__VITE_ASSET__IW2XY288__"